module.exports = __webpack_public_path__ + "img/smartx-logo.fd788215.png";